<template>
    <notification :active="active" :message="message" @close="hide" />
</template>
<script>
import Notification from './Notification';
import { mapActions, mapState } from 'vuex';

export default {
    name: 'notification-container',
    methods: {
        ...mapActions('notification', ['hide']),
    },
    computed: {
        ...mapState('notification', ['active', 'message']),
    },
    components: {
        Notification,
    }
}
</script>



// WEBPACK FOOTER //
// NotificationContainer.vue?113c5abe